import { render, staticRenderFns } from "./contractDetailTabMW.vue?vue&type=template&id=7225336b&scoped=true&"
import script from "./contractDetailTabMW.vue?vue&type=script&lang=js&"
export * from "./contractDetailTabMW.vue?vue&type=script&lang=js&"
import style0 from "./contractDetailTabMW.vue?vue&type=style&index=0&id=7225336b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7225336b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs,VTabsSlider})
